import {
  FETCH_E2E_NOTIFICATIONS,
  FETCH_E2E_NOTIFICATIONS_SUCCESS,
  FETCH_E2E_NOTIFICATIONS_FAILURE,
  UPDATE_E2E_NOTIFICATION_FLAG,
  UPDATE_E2E_NOTIFICATION_FLAG_SUCCESS,
  UPDATE_E2E_NOTIFICATION_FLAG_FAILURE,
} from './types';

import {
  fetchE2eNotifications as fetchE2eNotificationsApi,
  updateE2eNotificationMasterFlag,
  updateE2eNotificationClientFlag,
} from '../api';
import { fetchingError } from '../../../shared/store/actions';
import { errorNotification, successNotification } from '../../../shared/store/notificationActions';

export const fetchE2eNotifications = (onlyErrors = true) => async dispatch => {
  dispatch({
    type: FETCH_E2E_NOTIFICATIONS,
  });

  try {
    const notifications = await fetchE2eNotificationsApi(onlyErrors);
    return dispatch({
      type: FETCH_E2E_NOTIFICATIONS_SUCCESS,
      notifications,
    });
  } catch (error) {
    dispatch({
      type: FETCH_E2E_NOTIFICATIONS_FAILURE,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};

export const updateE2eNotificationFlag = ({ jobId, schemaType, errorMsgFlag, onlyErrors }) => async dispatch => {
  const updateKey = `${schemaType}-${jobId}`;
  dispatch({
    type: UPDATE_E2E_NOTIFICATION_FLAG,
    updateKey,
  });

  try {
    if (schemaType === 'master') {
      await updateE2eNotificationMasterFlag(jobId, errorMsgFlag);
    } else {
      await updateE2eNotificationClientFlag(jobId, errorMsgFlag);
    }

    dispatch(successNotification(
      errorMsgFlag === 'Y' ? 'Marked as error' : 'Removed from errors'
    ));
    if (typeof onlyErrors === 'boolean') {
      dispatch(fetchE2eNotifications(onlyErrors));
    }
    return dispatch({
      type: UPDATE_E2E_NOTIFICATION_FLAG_SUCCESS,
      jobId,
      schemaType,
      errorMsgFlag,
      updateKey,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_E2E_NOTIFICATION_FLAG_FAILURE,
      updateKey,
    });

    if (error.isFetchingError) {
      dispatch(fetchingError());
      dispatch(errorNotification(error.message));
      return;
    }
    throw error;
  }
};
